import {ActionList, ActionMenu} from '@primer/react'
import {useMemo} from 'react'

import type {DraftOrExistingIssue} from '../content-preview-types'
import styles from './CreateIssuePreview.module.css'
import {IssueIcon} from './IssueIcon'
import type {TreeNode} from './use-draft-issue-tree-map'

export function ParentSelector({
  node,
  onItemSelected,
}: {
  node: TreeNode<DraftOrExistingIssue>
  onItemSelected: (node: TreeNode<DraftOrExistingIssue>) => void
}) {
  const ancestors = useMemo(() => {
    const stack = []
    let current: TreeNode<DraftOrExistingIssue> | null = node
    while (current) {
      stack.push(current)
      current = current.parent
    }
    return stack.reverse()
  }, [node])

  if (!node.parent) return

  return (
    <ActionMenu>
      <ActionMenu.Button variant="invisible" className={styles.parentSelectorAnchor}>
        <span className="fgColor-muted">Parent:</span> {node?.parent?.item.name}
      </ActionMenu.Button>
      <ActionMenu.Overlay width="large">
        <ActionList>
          {ancestors.map((ancestor, index) => (
            <ActionList.Item
              key={ancestor.item.tag}
              active={ancestor.item.tag === node.item.tag}
              onSelect={() => onItemSelected(ancestor)}
              style={{paddingLeft: `calc(${index} * var(--base-size-12))`}}
            >
              <ActionList.LeadingVisual>
                <IssueIcon {...ancestor.item} />
              </ActionList.LeadingVisual>
              <div className={styles.truncateText}>{ancestor.item.name}</div>
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
